/**
 * Regole di programmazione dell'invio newsletter.
 *
 * Si può programmare anche per oggi, purché l'orario sia almeno LEAD_MINUTES avanti:
 * un margine serve perché lo scheduler passa una volta al minuto e perché fra la scelta
 * dell'orario e il salvataggio passa del tempo.
 *
 * Le regole stanno qui e non nei componenti perché valgono in tre punti (composizione,
 * dettaglio e controlli di invio) e devono restare allineate.
 */
import dayjs from 'dayjs';

/** Anticipo minimo rispetto ad adesso, in minuti. */
export const LEAD_MINUTES = 5;

/** Primo istante programmabile. */
export const minScheduleDateTime = () => dayjs().add(LEAD_MINUTES, 'minute');

/** Primo giorno programmabile: oggi. */
export const minScheduleDate = () => dayjs().startOf('day');

/**
 * Compone data e ora in un unico istante (i secondi si azzerano: l'utente sceglie i minuti).
 * @returns {import('dayjs').Dayjs|null} null se manca uno dei due
 */
export const composeScheduleDateTime = (date, time) => {
  if (!date || !time) return null;

  return dayjs(date).hour(dayjs(time).hour()).minute(dayjs(time).minute()).second(0).millisecond(0);
};

/** true se la data scelta è oggi: solo allora l'orario ha un limite inferiore. */
export const isToday = (date) => (date ? dayjs(date).isSame(dayjs(), 'day') : false);

/**
 * Verifica che l'istante scelto sia programmabile.
 * @returns {boolean} true se è troppo vicino (o nel passato), quindi da rifiutare
 */
export const isScheduleTooSoon = (date, time) => {
  const dt = composeScheduleDateTime(date, time);
  if (!dt) return false; // campi incompleti: se ne occupa la validazione dei campi obbligatori

  return dt.isBefore(minScheduleDateTime());
};

/** Messaggio d'errore unico, così i tre punti dicono la stessa cosa. */
export const scheduleTooSoonMessage = () =>
  `L'orario di invio deve essere almeno ${LEAD_MINUTES} minuti dopo l'ora attuale (dalle ${minScheduleDateTime().format('HH:mm')}).`;
